(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[8026],{

/***/ 26117:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/dashboard",
      function () {
        return __webpack_require__(21676);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 42901:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ common_MenuLayout; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./src/components/common/AppMenu.tsx
var AppMenu = __webpack_require__(40758);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./node_modules/@mantine/core/esm/Menu/Menu.js + 13 modules
var Menu = __webpack_require__(88002);
// EXTERNAL MODULE: ./node_modules/@mantine/core/esm/Button/Button.js + 3 modules
var Button = __webpack_require__(67841);
// EXTERNAL MODULE: ./node_modules/@mantine/core/esm/Drawer/Drawer.js + 4 modules
var Drawer = __webpack_require__(92716);
// EXTERNAL MODULE: ./node_modules/@mantine/core/esm/Divider/Divider.js + 1 modules
var Divider = __webpack_require__(54777);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./src/services/config.tsx
var config = __webpack_require__(35618);
// EXTERNAL MODULE: ./src/hooks/useAccount.tsx
var useAccount = __webpack_require__(98786);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(25675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: ./src/utils/format.ts
var format = __webpack_require__(6767);
// EXTERNAL MODULE: ./node_modules/wagmi/dist/index.js + 25 modules
var dist = __webpack_require__(69077);
;// CONCATENATED MODULE: ./src/components/common/AppMobileMenu.tsx











var AppMobileMenu = function() {
    var ref = (0,react.useState)(false), drawerOpened = ref[0], setDrawerOpened = ref[1];
    var router = (0,next_router.useRouter)();
    var ref1 = (0,useAccount/* default */.Z)(), login = ref1.login, logout = ref1.logout, isLogin = ref1.isLogin, address = ref1.address;
    var chain = (0,dist/* useNetwork */.LN)().chain;
    var switchNetwork = (0,dist/* useSwitchNetwork */.g0)().switchNetwork;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "relative z-10 h-[56px]",
        style: {
            filter: "drop-shadow(15px 4px 40px rgba(0, 0, 0, 0.1))"
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "bg-white ",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "layout-content flex h-[60px] items-center justify-between px-5 md:px-14",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "action block sm:hidden",
                            onClick: function() {
                                setDrawerOpened(true);
                            },
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                src: "/assets/burger.png",
                                width: 18,
                                height: 15
                            })
                        }),
                        isLogin && /*#__PURE__*/ (0,jsx_runtime.jsxs)(Menu/* Menu */.v, {
                            shadow: "md",
                            position: "bottom-end",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Menu/* Menu.Target */.v.Target, {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* Button */.z, {
                                            className: "btn-pri px-6 ",
                                            children: (0,format/* trimAddr */.nM)(address, 1)
                                        })
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Menu/* Menu.Dropdown */.v.Dropdown, {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Menu/* Menu.Label */.v.Label, {
                                            children: "Select a Network"
                                        }),
                                        AppMenu/* menus.map */.IJ.map(function(menu) {
                                            return /*#__PURE__*/ (0,jsx_runtime.jsx)(Menu/* Menu.Item */.v.Item, {
                                                icon: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                    src: menu.icon,
                                                    alt: "ethereum",
                                                    className: "h-4 w-4"
                                                }),
                                                onClick: function() {
                                                    // @ts-ignore
                                                    switchNetwork(menu.chain.id);
                                                },
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                                    className: "font-bold",
                                                    children: [
                                                        menu.name,
                                                        (chain === null || chain === void 0 ? void 0 : chain.id) === menu.chain.id ? "(Active)" : null
                                                    ]
                                                })
                                            }, menu.name);
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Menu/* Menu.Label */.v.Label, {
                                            children: "Test Network"
                                        }),
                                        AppMenu/* testNetworkMenus.map */.kG.map(function(menu) {
                                            return /*#__PURE__*/ (0,jsx_runtime.jsx)(Menu/* Menu.Item */.v.Item, {
                                                icon: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                    src: menu.icon,
                                                    alt: "ethereum",
                                                    className: "h-4 w-4"
                                                }),
                                                onClick: function() {
                                                    // @ts-ignore
                                                    switchNetwork(menu.chain.id);
                                                },
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                                    className: "font-bold",
                                                    children: [
                                                        menu.name,
                                                        (chain === null || chain === void 0 ? void 0 : chain.id) === menu.chain.id ? "(Active)" : null
                                                    ]
                                                })
                                            }, menu.name);
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Menu/* Menu.Divider */.v.Divider, {}),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Menu/* Menu.Item */.v.Item, {
                                            onClick: function() {
                                                return navigator.clipboard.writeText(address || "");
                                            },
                                            children: "Copy address"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Menu/* Menu.Item */.v.Item, {
                                            onClick: logout,
                                            children: "Disconnect wallet"
                                        })
                                    ]
                                })
                            ]
                        }),
                        !isLogin && /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* Button */.z, {
                            className: "px-6",
                            onClick: login,
                            children: "Connect"
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Drawer/* Drawer */.d, {
                opened: drawerOpened,
                onClose: function() {
                    return setDrawerOpened(false);
                },
                padding: "xl",
                size: "sm",
                trapFocus: false,
                withCloseButton: false,
                classNames: {
                    root: "p-0",
                    body: "h-full p-0",
                    overlay: "!bg-[rgba(0,0,0,0.8)]"
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "w-full h-full flex-shrink-0 bg-dark1 px-4 py-6 flex flex-col",
                    children: [
                        [
                            (0,config/* getRoute */.B)("dashboard")
                        ].map(function(tab) {
                            var isActive = router.pathname === tab.route;
                            return /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                href: "".concat(tab.route),
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "flex py-3 pb-0 action",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(tab.Icon, {
                                            className: "".concat(isActive ? "fill-[#87B5FF]" : "fill-[#8F8F8F]")
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                            className: "ml-2 text-sm font-semibold ".concat(isActive ? "text-white" : "text-[#8F8F8F]"),
                                            children: tab.label
                                        })
                                    ]
                                })
                            }, tab.id);
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Divider/* Divider */.i, {
                            color: "#3A3A3A",
                            className: "mt-7"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "py-4",
                            children: AppMenu/* tabs.map */.eA.map(function(tab) {
                                var isActive = router.pathname.indexOf(tab.route) === 0;
                                return /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                    href: "".concat(tab.route),
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "flex py-3 action last:pb-0",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(tab.Icon, {
                                                className: "".concat(isActive ? "fill-[#87B5FF]" : "fill-[#8F8F8F]")
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                className: "ml-2 text-sm font-semibold ".concat(isActive ? "text-white" : "text-[#8F8F8F]"),
                                                children: tab.label
                                            })
                                        ]
                                    })
                                }, tab.id);
                            })
                        })
                    ]
                })
            })
        ]
    });
};
/* harmony default export */ var common_AppMobileMenu = (AppMobileMenu);

// EXTERNAL MODULE: ./node_modules/react-div-100vh/dist/esm/index.js
var esm = __webpack_require__(66409);
// EXTERNAL MODULE: ./src/form/components/common/icons.tsx
var icons = __webpack_require__(85119);
// EXTERNAL MODULE: ./src/config/config.js
var config_config = __webpack_require__(35055);
// EXTERNAL MODULE: ./src/components/common/ConnectWallet.tsx + 1 modules
var ConnectWallet = __webpack_require__(12256);
;// CONCATENATED MODULE: ./src/components/common/MenuLayout.tsx









var MenuLayout = function MenuLayout(param) {
    var children = param.children;
    var height = (0,esm/* use100vh */.g)();
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "overflow-hidden flex flex-col",
        style: {
            height: height ? "".concat(height, "px") : "100vh"
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "h-[60px] flex-grow-0 flex items-center justify-between backdrop-blur bg-white px-6 sm:px-[60px] text-sm",
                style: {
                    filter: "drop-shadow(15px 4px 40px rgba(0, 0, 0, 0.1))"
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                        href: "/",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                            src: "/airdrop_assets/karatdao4x.png",
                            width: 150,
                            height: 40,
                            className: "-translate-y-1 action"
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "flex items-center gap-6",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(ConnectWallet/* default */.Z, {}),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                href: "/",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "action text-primary font-semibold",
                                    children: "Exit app"
                                })
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "flex-1 flex flex-col sm:flex-row overflow-hidden",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "p-3 pr-0 hidden sm:block",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(AppMenu/* default */.ZP, {})
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "block sm:hidden",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(common_AppMobileMenu, {})
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "flex-1 overflow-x-hidden",
                        children: [
                            config_config/* isMaintenance */.b6 && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "mt-3 mx-5 sm:mx-[7vw] flex items-center justify-center bg-bg_brown mb-2 font-bold rounded-lg p-4",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(icons/* TrumpetIcon */.Db, {
                                        className: "mr-2"
                                    }),
                                    "Server is under maintenance"
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                children: children
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var common_MenuLayout = (MenuLayout);


/***/ }),

/***/ 72441:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _mantine_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67841);


var FeatureCard = function(param) {
    var name = param.name, intro = param.intro, btnText = param.btnText, Icon = param.Icon, onClick = param.onClick, children = param.children, disable = param.disable;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: "pt-[55px] pb-[61px] px-9 rounded-lg bg-featureCardBg bg-cover relative",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Icon, {
                className: "fill-[rgba(255,255,255,0.15)] absolute right-6 top-0 w-fit ",
                style: {
                    transform: "rotate(10deg) scale(1.2)"
                }
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "font-semibold text-dark1 text-2xl",
                children: name
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "font-normal text-sm text-dark1 mt-4 whitespace-pre-line",
                children: intro
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: "flex items-center mt-10",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mantine_core__WEBPACK_IMPORTED_MODULE_1__/* .Button */ .z, {
                        variant: "filled",
                        radius: "xl",
                        size: "md",
                        classNames: {
                            root: "w-[165px]"
                        },
                        onClick: onClick,
                        disabled: !!disable,
                        children: btnText
                    }),
                    children
                ]
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (FeatureCard);


/***/ }),

/***/ 21676:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* binding */ App; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _services_config__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(35618);
/* harmony import */ var _components_common_MenuLayout__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(42901);
/* harmony import */ var _components_dashboard_FeatureCard__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(72441);
/* harmony import */ var _components_common_icons__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(58163);
/* harmony import */ var _components_common_PageHead__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(47270);
/* harmony import */ var _config_config__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(35055);








function App() {
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_1__.useRouter)();
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_components_common_MenuLayout__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_common_PageHead__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {}),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: "grid grid-cols-1 sm:grid-cols-2 gap-6 pt-8 ".concat(_config_config__WEBPACK_IMPORTED_MODULE_7__/* .isMaintenance */ .b6 ? "sm:pt-10" : "sm:pt-[100px]", "  pb-10 px-5 sm:px-[7vw]"),
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_dashboard_FeatureCard__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                        name: "Collect wallets",
                        intro: "Create a KARATForm to collect wallets so that you can view useful insights.",
                        btnText: "Create form",
                        Icon: _components_common_icons__WEBPACK_IMPORTED_MODULE_5__/* .FormIcon */ .Kj,
                        onClick: function() {
                            router.push((0,_services_config__WEBPACK_IMPORTED_MODULE_2__/* .getRoute */ .B)("form").route);
                        }
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_dashboard_FeatureCard__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                        name: "Analyze wallets",
                        intro: "View informative wallet insights like ETH balance, blue chip NFTs, tags and social media accounts.",
                        btnText: "Analyze wallets",
                        Icon: _components_common_icons__WEBPACK_IMPORTED_MODULE_5__/* .InsightsIcon */ .Ew,
                        onClick: function() {
                            router.push((0,_services_config__WEBPACK_IMPORTED_MODULE_2__/* .getRoute */ .B)("analytics").route);
                        }
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_dashboard_FeatureCard__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                        name: "Create airdrop",
                        intro: "Create a NFT or token airdrop through our launchpad and share it with your audience. This helps to increase your project’s engagement and visibility.",
                        btnText: "Create airdrop",
                        Icon: _components_common_icons__WEBPACK_IMPORTED_MODULE_5__/* .GiftIcon */ .Og,
                        onClick: function() {
                            router.push((0,_services_config__WEBPACK_IMPORTED_MODULE_2__/* .getRoute */ .B)("airdrop").route);
                        }
                    })
                ]
            })
        ]
    });
}


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [3454,2280,6034,7172,2256,9774,2888,179], function() { return __webpack_exec__(26117); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);